<template>
  <div id="commonPage">
    <section>
      <div class="topBox">
        <div class="contentBox">
          <addCase :token="token" :typeId="typeId" />
          <serviceCase
            :case_list="case_list"
            :num_list="num_list"
            :routePath="'ComAwait'"
          ></serviceCase>
        </div>
      </div>
      <div class="centerBox">
        <div class="contentBox">
          <el-button type="primary" class="search" @click="toPath"
            ><i class="el-icon-search"></i> 搜索</el-button
          >
          <div class="top">
            <span :class="{ active: caseIndex == 1 }" @click="caseIndex = 1"
              >进行中案件（{{ total }}）</span
            >
            <img src="./../commonPage/img/line.png" class="line" />
            <span :class="{ active: caseIndex == 2 }" @click="caseIndex = 2"
              >近期完成案件（{{ total1 }}）</span
            >
          </div>
          <div v-show="caseIndex == 1">
            <div class="content" v-if="nowCaseArr.length != 0">
              <vcase
                v-for="(item, index) in nowCaseArr"
                :key="index"
                @setData="getnowCase"
                :nowCaseItemList="item"
                :btnText="1"
                :keyIndex="index"
                :pstnCallLstList="pstnCallLstList"
              ></vcase>
              <div v-if="moreshow==true" style="width:204px;height:40px;border:1px solid #e7e7e7;margin: 0 auto;line-height: 40px;text-align: center;cursor:pointer" @click="more()">查看更多</div>
               <div v-else style="width:204px;height:40px;border:1px solid #e7e7e7;margin: 0 auto;line-height: 40px;text-align: center;cursor:pointer" >暂无更多</div>
              <!-- <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-sizes="[20]"
                  :page-size="100"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination> -->
            </div>
            <div class="content" v-else>
              <div class="kongBox">
                <img src="./../commonPage/img/kong.png" />
                <p>当前暂无数据哦～</p>
              </div>
            </div>
          </div>
          <div v-if="caseIndex == 2">
            <div class="content" v-if="completeCaseArr.length != 0">
              <vcase
                v-for="(item, index) in completeCaseArr"
                :key="index"
                @setData="getCenterFinishCase"
                :nowCaseItemList="item"
                :btnText="2"
                :keyIndex="index"
                :pstnCallLstList="pstnCallLstList"
              ></vcase>
              <!-- <div v-if="moreshow1==true" style="width:204px;height:40px;border:1px solid #e7e7e7;margin: 0 auto;line-height: 40px;text-align: center;cursor:pointer" @click="more1()">查看更多</div>
              <div v-else style="width:204px;height:40px;border:1px solid #e7e7e7;margin: 0 auto;line-height: 40px;text-align: center;cursor:pointer" >暂无更多</div> -->
              <!-- <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage41"
                  :page-sizes="[20]"
                  :page-size="100"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total1">
                </el-pagination> -->
            </div>
            <div class="content" v-else>
              <div class="kongBox">
                <img src="./../commonPage/img/kong.png" />
                <p>当前暂无数据哦～</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <vfooter></vfooter>
  </div>
</template>

<script>
import vcase from "./case";
import vfooter from "./footer";
import serviceCase from "@/views/commonPage/service";
import addCase from "@/components/cmd_center/addcase";
import constants from "@/util/constants.js";
import {
  seversList,
  getallGoingCase,
  getCaseNum2,
  getCenterFinishCase,
  getAllCoordinatedCases,
  pstnCallLst,
} from "@/views/axios/api.js";
export default {
  data() {
    return {
      moreshow:true,
      moreshow1:true,
      scrollHeightInd:0,
      scrollIndex: 1,
      scrollIndex1:1,
      count: 5,
      start: 0,
      total: 0,
      currentPage4: 0,
      currentPage41: 0,
      total1: 0,
      count1: 5,
      start1: 0,
      insti: JSON.parse(window.localStorage.getItem("insti")), //头部数据
      token: JSON.parse(window.localStorage.getItem("data")).data,
      caseIndex: 1, //切换进行中，还是近期完成
      case_list: [], //icon
      nowCaseArr: [], //进行中的案件
      xingshiCaseArr: [], //星使
      num_list: [],
      completeCaseArr: [], //已完成的案件
      waitingList: [], //等待
      typeId: 1,
      statusArr: [
        "等待分公司确认", //210
        "等待总司调处确认", //211
        "进入正常流程，等待海外代表接入，或直接接单等后续流程", //230
        "分公司拒绝派单", //114
        "总司调处拒绝派单", //115
      ],
      pstnCallLstList: [],
    };
  },
  components: {
    vcase,
    vfooter,
    serviceCase,
    addCase,
  },
  mounted() {
    this.getSeverFun();
    this.getnowCase();
    this.getCaseNum();
    this.getCenterFinishCase();
    // this.getAllCoordinatedCasesList();
    // window.addEventListener("scroll", this.handleScroll, true);
    this.pstnCallLst();
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
  },
  watch: {
    languageIndex() {
      this.getnowCase();
      this.getCenterFinishCase();
    },
  },
  methods: {
    more1() {
       this.start1 = (this.scrollIndex1 - 1) * this.count1;
        this.getCenterFinishCase();
        this.count1 = 5;
    },
    more() {
       this.start = (this.scrollIndex - 1) * this.count;
       this.getnowCase();
        this.count = 5;
    },
    handleSizeChange(val) {
      this.count = val;
      this.getnowCase();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.start = (val - 1) * this.count;
      // this.start = val * 10
      this.getnowCase();
    },
    handleSizeChange1(val) {
      this.count1 = val;
      this.getCenterFinishCase();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange1(val) {
      this.start1 = (val - 1) * this.count1;
      // this.start = val * 10
      this.getCenterFinishCase();
      console.log(`当前页: ${val}`);
    },
    getSeverFun() {
      //门急诊就医
      var data = {
        token: this.token,
        parentId: 0,
      };
      seversList(data)
        .then((res) => {
          this.case_list = res.data.obj;
          localStorage.setItem("selectList", JSON.stringify(res.data.obj));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.$router.push({
        name: "searchCase",
      });
    },
    getnowCase() {
      //当前案件管理
      // this.nowCaseArr = [];
      var data = {
        token: this.token,
        start: this.start,
        count: this.count,
      };
      getallGoingCase(data)
        .then((res) => {
          console.log(res.data.obj)
          this.scrollIndex = this.scrollIndex + 1;
          this.total = res.data.total;
          if(res.data.obj.length != 0) {
             res.data.obj.forEach((item) => {
            var list = this.formattingData1(item);
            this.nowCaseArr.push(list);
            
          });
          }else {
             this.moreshow = false
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formattingData1(data) {
      console.log(data)
      var caseArr = [];
      if(data[0].obj.obj.incidentType != 900) {
        data.map((v) => {
        var objNew = {};
        objNew.name = v.obj.victimList[0].obj.victimName;
        objNew.caseNo = v.obj.obj.caseNo;
        objNew.contact = v.obj.obj.reporterContact;
        objNew.insuranceLiabilityStatus = v.obj.obj.insuranceLiabilityStatus;
        objNew.typename = v.obj.obj.otherTypeName || v.obj.incidentTypeStr;
        objNew.typenameEn = v.obj.incidentTypeStrEn;
        objNew.caseState = v.obj.obj.caseState;
        objNew.solutionState = v.obj.solutionState;
        objNew.typeId = v.obj.obj.incidentType;
        objNew.regulatorId = v.obj.obj.regulatorId;
        objNew.subRegulatorId = v.obj.obj.subRegulatorId;
        objNew.op = constants.state2op(v.obj.obj.caseState);
        objNew.id = v.obj.obj.id;
        if (v.obj.contractType == 1) {
          objNew.contractTypeName = "大包";
        } else if (v.obj.contractType == 2) {
          objNew.contractTypeName = "小包";
        } else if (v.obj.contractType == 3) {
          objNew.contractTypeName = "纯服务";
        }
        //计算总耗时
        objNew.alltime = this.timeToStr(
          v.obj.obj.lastCheckPtsTs,
          v.obj.obj.reportTs,
          v.obj.obj.caseState
        );

        objNew.tableData = [];
        if (this.languageIndex == 0) {
          v.obj2.operation.map((o) => {
            objNew.tableData.push({
              oper: o.instiName + "账号:" + o.passport, //操作方
              node: o.obj.opDesc, //操作节点
              detail: o.obj.opStateText, //操作细节
              nstate: "已完成", //当前状态
              time: constants.time(o.obj.updateAt), //时间
            });
          });
        } else {
          v.obj2.operation.map((o) => {
            objNew.tableData.push({
              oper: o.instiNameEn + " Account number：" + o.passport, //操作方
              node: o.obj.opDescEn ? o.obj.opDescEn : o.obj.opDesc, //操作节点
              detail: o.obj.opStateTextEn, //操作细节
              nstate: "Completed", //当前状态
              time: constants.time(o.obj.updateAt), //时间
            });
          });
        }

        objNew.serviceLst = [];
        objNew.serviceIndex = 0;
        if (v.obj2.serviceLst) {
          v.obj2.serviceLst.map((o) => {
            objNew.serviceLst.push({
              name: o.dict ? o.dict.name : "暂无", //结点名称
              nameEn: o.dict ? o.dict.nameEn : "none", //结点名称
              state: o.obj.state,
            });
            if (o.obj.state && o.obj.state == 1) {
              objNew.serviceIndex += 1;
            }
          });
        }
        caseArr.push(objNew);
      });
      }else {
        data.map((v) => {
        var objNew = {};
        objNew.name = v.obj.victimList[0].obj.victimName;
        objNew.caseNo = v.obj.obj.caseNo;
        objNew.contact = v.obj.obj.reporterContact;
        objNew.insuranceLiabilityStatus = v.obj.obj.insuranceLiabilityStatus;
        objNew.typename = v.obj.obj.otherTypeName || v.obj.incidentTypeStr;
        objNew.typenameEn = v.obj.incidentTypeStrEn;
        objNew.caseState = v.obj.obj.caseState;
        objNew.solutionState = v.obj.solutionState;
        objNew.typeId = v.obj.obj.incidentType;
        objNew.regulatorId = v.obj.obj.regulatorId;
        objNew.subRegulatorId = v.obj.obj.subRegulatorId;
        objNew.op = constants.state2op(v.obj.obj.caseState);
        objNew.id = v.obj.obj.id;
        if (v.obj.contractType == 1) {
          objNew.contractTypeName = "大包";
        } else if (v.obj.contractType == 2) {
          objNew.contractTypeName = "小包";
        } else if (v.obj.contractType == 3) {
          objNew.contractTypeName = "纯服务";
        }
        //计算总耗时
        objNew.alltime = this.timeToStr(
          v.obj.obj.lastCheckPtsTs,
          v.obj.obj.reportTs,
          v.obj.obj.caseState
        );

        objNew.tableData = [];
        if (this.languageIndex == 0) {
          v.obj2.operation.map((o) => {
            o.content = JSON.parse(o.content)
            objNew.tableData.push({
              oper: o.content.serviceName, //服务方
              node: o.content.ptText, //操作节点
              detail:o.content.serviceContent, //操作细节
              nstate: "已完成", //当前状态
              time: constants.time(o.content.time), //时间
            });
          });
        } else {
          v.obj2.operation.map((o) => {
            objNew.tableData.push({
              oper: o.content.serviceName, //服务方
              node: o.content.ptText, //操作节点
              detail: o.content.serviceContent, //操作细节
              nstate: "Completed", //当前状态
              time: constants.time(o.content.time), //时间
            });
          });
        }

        objNew.serviceLst = [];
        objNew.serviceIndex = 0;
        // if (v.obj2.serviceLst) {
        //   v.obj2.serviceLst.map((o) => {
        //     objNew.serviceLst.push({
        //       name: o.dict ? o.dict.name : "暂无", //结点名称
        //       nameEn: o.dict ? o.dict.nameEn : "none", //结点名称
        //       state: o.obj.state,
        //     });
        //     if (o.obj.state && o.obj.state == 1) {
        //       objNew.serviceIndex += 1;
        //     }
        //   });
        // }
        caseArr.push(objNew);
      });
      }
     
      return caseArr;
    },
    formattingData(data) {
      var caseArr = [];
      data.data.obj.map((v) => {
        var objNew = {};
        objNew.name = v.obj.victimList[0].obj.victimName;
        objNew.caseNo = v.obj.obj.caseNo;
        objNew.contact = v.obj.obj.reporterContact;
        objNew.insuranceLiabilityStatus = v.obj.obj.insuranceLiabilityStatus;
        objNew.typename = v.obj.obj.otherTypeName || v.obj.incidentTypeStr;
        objNew.typenameEn = v.obj.incidentTypeStrEn;
        objNew.caseState = v.obj.obj.caseState;
        objNew.solutionState = v.obj.solutionState;
        objNew.typeId = v.obj.obj.incidentType;
        objNew.op = constants.state2op(v.obj.obj.caseState);
        objNew.id = v.obj.obj.id;
        if (v.obj.contractType == 1) {
          objNew.contractTypeName = "大包";
        } else if (v.obj.contractType == 2) {
          objNew.contractTypeName = "小包";
        } else if (v.obj.contractType == 3) {
          objNew.contractTypeName = "纯服务";
        }
        //计算总耗时
        if (v.obj2.operation.length != 0) {
          console.log(v);
          objNew.alltime = this.timeToStr(
            v.obj.obj.lastCheckPtsTs,
            v.obj.obj.reportTs,
            v.obj.obj.caseState
          );
        }

        objNew.tableData = [];
        if (this.languageIndex == 0) {
          v.obj2.operation.map((o) => {
            objNew.tableData.push({
              oper: o.instiName + "账号:" + o.passport, //操作方
              node: o.obj.opDesc, //操作节点
              detail: o.obj.opStateText, //操作细节
              nstate: "已完成", //当前状态
              time: constants.time(o.obj.updateAt), //时间
            });
          });
        } else {
          v.obj2.operation.map((o) => {
            objNew.tableData.push({
              oper: o.instiNameEn + " Account number：" + o.passport, //操作方
              node: o.obj.opDescEn ? o.obj.opDescEn : o.obj.opDesc, //操作节点
              detail: o.obj.opStateTextEn, //操作细节
              nstate: "Completed", //当前状态
              time: constants.time(o.obj.updateAt), //时间
            });
          });
        }

        objNew.serviceLst = [];
        objNew.serviceIndex = 0;
        if (v.obj2.serviceLst) {
          v.obj2.serviceLst.map((o) => {
            objNew.serviceLst.push({
              name: o.dict ? o.dict.name : "暂无", //结点名称
              nameEn: o.dict ? o.dict.nameEn : "none", //结点名称
              state: o.obj.state,
            });
            if (o.obj.state && o.obj.state == 1) {
              objNew.serviceIndex += 1;
            }
          });
        }
        caseArr.push(objNew);
      });
      return caseArr;
    },
    timeToStr(time1, time2, state) {
      //时间转换
      var date3 = "";
      if (state == 110 || state == 111) {
        date3 = time1 - time2;
      } else {
        date3 = new Date().getTime() - time2;
      }

      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      //		      return days + "天 " + hours + "小时 " + minutes + " 分钟";
      return days + "天 " + hours + "小时 ";
    },
    //跳转编辑
    gonewstar(item) {
      var routerName = "newstar";
      this.$router.push({
        name: routerName,
        params: {
          token: this.token,
        },
        query: {
          item: item,
        },
      });
    },
    //转换状态
    stasusFun(caseState) {
      var status = "";
      if (caseState == "210") {
        status = this.statusArr[0];
      } else if (caseState == "211") {
        status = this.statusArr[1];
      } else if (caseState == "230") {
        status = this.statusArr[2];
      } else if (caseState == "114") {
        status = this.statusArr[4];
      } else {
        //115
        status = this.statusArr[5];
      }
      return status;
    },
    tocase(id) {
      let token = this.token;
      let insti = this.insti;
      let name = "";
      this.case_list.map((v) => {
        if (v.id == id) {
          name = v.name;
        }
      });
      window.localStorage.setItem(
        "case",
        JSON.stringify({
          case: "Await",
        })
      );
      this.$router.push({
        name: "Await",
        params: {
          token: token,
          insti: insti,
          flag: false,
        },
        query: {
          typeId: id,
          name: name,
        },
      });
    },
    getCaseNum() {
      //获取类别数量
      var data = {
        token: this.token,
      };
      getCaseNum2(data)
        .then((res) => {
          this.num_list = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCenterFinishCase() {
      //获取完成案件
      // this.completeCaseArr = [];
      var data = {
        token: this.token,
        count: this.count1,
        start:this.start1
      };
      getCenterFinishCase(data)
        .then((res) => {
          this.scrollIndex1 = this.scrollIndex1+ 1;
          this.total1 = res.data.total;
          if(res.data.obj.length != 0) {
             res.data.obj.forEach((item) => {
            var list = this.formattingData1(item);
            this.completeCaseArr.push(list);
          });
          }else {
             this.moreshow1 = false
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pstnCallLst() {
      pstnCallLst({
        token: this.token,
      })
        .then((res) => {
          console.log(res);
          this.pstnCallLstList = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped="scoped">
/* 星使start */
.xingshiBox {
  border: 1px solid #f8dc40;
  padding: 0 40px;
  padding-bottom: 40px;
  background-color: white;
  margin-bottom: 30px;
}

.xingshiBox h4 {
  width: 100px;
  height: 50px;
  background-color: #f8dc40;
  border-radius: 0 0 100px 100px;
  text-align: center;
  color: #fff;
  line-height: 50px;
  margin: auto;
}

.xingshiBox ul li {
  float: left;
  margin-left: 25px;
}

.xingshiBox .btn {
  border: 0;
  height: 40px;
  line-height: 40px;
  display: block;
  background-color: #00abfa;
  color: white;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  border-radius: 5px;
  float: right;
  margin-right: 25px;
}

.xingshiBox .table1 {
  margin-top: 30px;
}

.text2 {
  margin-top: 20px;
  font-size: 18px;
}

.text2 span {
  color: #ff7200;
}

.btnWorkbench {
  overflow: hidden;
  border: 1px solid #f5ebb5;
  background: #fffce9;
  padding: 20px 10px;
}

.btnWorkbench button {
  border: 5px solid #f8dc40;
  height: 45px;
  padding: 0 20px;
  background: #fbea8c;
  border-radius: 5px;
  color: #c27506;
  cursor: pointer;
  outline: none;
  margin-right: 20px;
}

/* .btnWorkbench button:first-child{float: left;margin-left: 60px;} */
.btnWorkbench > div {
  float: right;
  margin-right: 20px;
}

.btnWorkbench > div button {
  margin-left: 60px;
}

/* 星使start */
.topBox {
  padding: 50px 0;
  background-color: white;
}

.contentBox {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.contentBox .search {
  position: absolute;
  width: 100px;
  top: 10px;
  right: 10px;
}

.centerBox {
  background-color: #f8fafe;
  padding: 20px 0;
}

.centerBox .top {
  text-align: center;
  padding-bottom: 30px;
}

.centerBox .top span {
  padding: 0 10px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  line-height: 50px;
  display: inline-block;
  vertical-align: middle;
}

.centerBox .top span:first-child {
  margin-right: 10px;
}

.centerBox .top span:last-child {
  margin-left: 10px;
}

.centerBox .top span.active {
  color: #00abfa;
  border-bottom: 2px solid #00abfa;
}

.centerBox .top .line {
  vertical-align: middle;
}

.centerBox .kongBox {
  text-align: center;
  padding: 160px 0;
}

.centerBox .kongBox p {
  color: #666;
  line-height: 40px;
}

.managementCase {
  padding: 15px;
  border: 1px solid #ffba00;
}

.managementCase h3 {
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 10px;
}

.managementCase h3 .red {
  color: #df1717;
  padding-left: 10px;
}

.managementCase .top li {
  margin-bottom: 10px;
}

.managementCase .top span {
  display: inline-block;
  vertical-align: middle;
}

.managementCase .top span.text1 {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.managementCase .top span.text2 {
  color: #00abfa;
  cursor: pointer;
}

.managementCase .top span.text3 {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/mainPase.vue